import { useConsumerSelector } from '..'
import { COUNTRY_FIELDS_HIDDEN } from '../../component/DriversLicence/constants'

export const useCountryStateIsShown = (): boolean => {
  const { accountCountry } = useConsumerSelector()
  if (typeof accountCountry === 'undefined') {
    return false
  }

  return !COUNTRY_FIELDS_HIDDEN[accountCountry]?.includes('state') ?? true
}
